export const scheduleStartTime = '06:00';
export const scheduleEndTime = '20:00';

export const shiftAdjustmentStartTime = '04:00';
export const shiftAdjustmenEndTime = '22:00';

export const engineerStartTime = '08:00';
export const engineerEndTime = '18:00';
